<button class="inline-flex align-middle px-4 py-1 bg-neutral-800 rounded-full">
  <i class="icon icon-{{ icon }} mr-2 text-white leading-6"></i>
  <span class="font-base font-bold text-base text-white">{{ text }}</span>
</button>
